<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "widget_product_preview_modal_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <web-general-settings [generalSettingsFormGroup]="generalSettingsFormGroup"></web-general-settings>
        <web-gallery-settings
            [widgetId]="widgetId"
            [gallerySettingsFormGroup]="gallerySettingsFormGroup"
            [cardKindViewType]="cardKindViewType"
            [isPreviewSettings]="true"
        ></web-gallery-settings>
        <!-- <web-info-block-settings [infoSettingsFormGroup]="infoSettingsFormGroup"></web-info-block-settings> -->
        <web-typography-settings
            [typographySettingsFormGroup]="typographySettingsFormGroup"
            [isPreviewSettings]="true"
        ></web-typography-settings>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
